import Crud from '../components/Users/Crud'
import Entity from '../components/Users/Entity'

let routes = {
    path: '/users',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/users',
            name: 'Crud',
            component: Crud
        },
        {
            path: '/users/add',
            name: 'Entity',
            component: Entity
        },
        {
            path: '/users/edit/:id?',
            name: 'Entity Edit',
            component: Entity
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/users.js